
import UserMixin from '@/_mixins/user'
import _ from 'lodash'

export default {
    name: 'UserSearch',
    mixins: [UserMixin],
    props: {
        value: String,
    },
    data() {
        return {
            users: null as Array<any> | null, // null = not searched, [] = no results
            searchTerm: this.value || '',
            selected: null,
            isSearching: false,
            isMenuOpen: false,
        }
    },
    methods: {
        setSelectedUser(user: any) {
            this.selected = user
            this.searchTerm = user.attributes.name
            this.$emit('select:user', user)
        },
        handleInputBlur() {
            // Wait for v-list-item@click to fire before closing menu
            setTimeout(() => (this.isMenuOpen = false), 200)
        },
        searchUser: _.debounce(async function search() {
            if (!this.searchTerm || this.searchTerm.length < 2) {
                this.users = this.selected = null
                return
            }

            if (this.searchTerm === this.selected?.attributes?.name) return

            this.isSearching = true
            this.users = await this.getUsers({
                'filter[kind]': 'normal',
                'filter[searchTerm]': this.searchTerm,
            })
            this.isSearching = false
            this.isMenuOpen = true

            if (this.users?.length === 0) this.selected = null
        }, 250),
    },
    watch: {
        searchTerm: function (value) {
            this.$emit('input', value)
            this.searchUser()
        },
    },
}
